var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-sidebar-group" }, [
    _c(
      "button",
      {
        staticClass: "ia-sidebar-row chat-sidebar-group__cabecalho",
        attrs: { type: "button", "aria-expanded": _vm.ariaExpanded },
        on: { click: _vm.alternar }
      },
      [
        _c("icon-svg", {
          staticClass: "flex-shrink-0",
          attrs: {
            name: _vm.chevron,
            size: _vm.tamanhoIcone,
            color: _vm.corIcone
          }
        }),
        _vm.temIcone
          ? _c("icon-svg", {
              staticClass: "flex-shrink-0",
              attrs: {
                name: _vm.iconName,
                size: _vm.tamanhoIcone,
                color: _vm.corIcone
              }
            })
          : _vm._e(),
        _c(
          "span",
          {
            staticClass:
              "chat-sidebar-group__titulo ia-texto-selo text-truncate"
          },
          [_vm._v(_vm._s(_vm.titulo))]
        ),
        _vm.mostraContador
          ? _c("span", { staticClass: "ia-sidebar-aux flex-shrink-0" }, [
              _vm._v(" " + _vm._s(_vm.contador) + " ")
            ])
          : _vm._e()
      ],
      1
    ),
    _vm.aberto
      ? _c(
          "div",
          { staticClass: "chat-sidebar-group__corpo" },
          [_vm._t("default")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }